import Service from '@/services/Service'
import { formataDataBD } from '@/utils/utils'

class ConstructionService extends Service {
  constructor() {
    super('CONSTRUCTION')
    this.resource = 'constructions'
  }
  translateToFirebird(obj) {
    // somente descomentar quando tiver tudo ok para o CRUD
    try {
      let parcelamentos = obj.newParcelamentos
        ? obj.newParcelamentos.map((current) => ({
            // FASE: current.faseObra,
            FASES: current.parcela_fases,
            SEQ: current.index,
            DATA: formataDataBD(current.data),
            VENCIMENTO:
              current.vencimento == 'A VISTA'
                ? formataDataBD(current.data)
                : formataDataBD(current.vencimento),
            CONDICAOPGTO: { CODIGO: current.codigoCondicao },
            CONDICAO: current.condicao,
            CONTA: current.conta ? { CODIGO: current.conta.CODIGO } : null,
            CT: current.ct,
            VALOR: current.valor,
            INFORMOUVALOR: current.informouValor,
          }))
        : []

      let fases =
        obj.fases.length > 0
          ? obj.fases.map((current) => ({
              ...current,
              fasesItens: obj.fasesItens.filter(
                (item) => item.FASE == current.FASE
              ),
              comissoes: obj.comissoes.filter(
                (comissao) => comissao.FASE == current.FASE
              ),
              // parcelas: parcelamentos.filter(
              //   (parcela) => parcela.FASE == current.FASE
              // ),
            }))
          : null

      let objFirebird = {
        NOME: obj.nome,
        CONTATO: obj.contato,
        // NASCIMENTO: obj.nascimento,  // nao tem no formulario
        FONE: obj.fone,
        FONE1: obj.fone1,
        UF: obj.uf,
        CEP: obj.cep,
        BAIRRO: obj.bairro,
        ENDERECO: obj.endereco,
        STATUS: obj.status,
        OBS: obj.observacao,
        AREA: obj.area,
        DATA: obj.data,
        // VALORDESCONTO: obj.valorDesconto, // nao tem no formulario
        // USUARIO: obj.usuario,
        // USUARIOLIBEROU: obj.usuarioLiberou,
        // DATALIBERACAO: obj.dataLiberacao,
        DATACONCLUSAO: obj.dataConclusao,
        // NUMEROO: obj.numero, // nao tem no formulario
        LATITUDE: obj.latitude,
        LONGITUDE: obj.longitude,
        TIPO: obj.tipo ? obj.tipo.value : null,
        // TAMANHO: obj.tamanho,
        // TEMPO: obj.tempo,
        TIPOEDIFICACAO: obj.tipoEdificacao ? obj.tipoEdificacao.value : null,
        ORIGEMDOCLIENTE: obj.origemCliente ? obj.origemCliente.value : null,
        HORARIODEENTREGA: obj.horarioEntrega,
        // DATAMEDICAO: obj.dataMedicao, // nao tem no formulario
        PREVISAOCONCLUSAO: obj.previsaoConclusao,
        MATERIALDISPONIVEL: obj.materialDisponivel,

        regiao: obj.regiao,
        rota: obj.rota,

        cidade: null,
        empresa: obj.empresa,
        engenheiro: obj.engenheiro,
        arquiteto: obj.arquiteto,
        fases: fases,
        parcela_fases: parcelamentos,
      }

      if (obj.cidade && !obj.cidade.DESCRICAO) {
        objFirebird.cidade = {
          DESCRICAO: obj.cidade.toUpperCase(),
        }
      } else {
        objFirebird.cidade = obj.cidade
      }

      return objFirebird
    } catch (error) {
      console.error(error)
    }
  }

  translateFromFirebird(obj) {
    let objeto = {
      codigo: obj.CODIGO,
      nome: obj.NOME,
      contato: obj.CONTATO,
      // nascimento: obj.NASCIMENTO,
      fone: obj.FONE,
      fone1: obj.FONE1,
      uf: obj.UF,
      cep: obj.CEP,
      bairro: obj.BAIRRO,
      endereco: obj.ENDERECO,
      observacao: obj.OBS,
      area: obj.AREA,
      data: obj.DATA ? obj.DATA.substring(0, 10) : null,
      // valorDesconto: obj.VALORDESCONTO,
      usuario: obj.USUARIO,
      usuarioLiberou: obj.USUARIOLIBEROU,
      dataLiberacao: obj.DATALIBERACAO
        ? obj.DATALIBERACAO.substring(0, 10)
        : null,
      dataConclusao: obj.DATACONCLUSAO
        ? obj.DATACONCLUSAO.substring(0, 10)
        : null,
      usuarioAlteracao: obj.USUARIOALTEROUORCAMENTO,
      // numero: obj.NUMEROO,
      latitude: obj.LATITUDE ? parseInt(obj.LATITUDE) : null,
      longitude: obj.LONGITUDE ? parseInt(obj.LONGITUDE) : null,
      tamanho: obj.TAMANHO,
      tempo: obj.TEMPO,
      horarioEntrega: obj.HORARIODEENTREGA,
      dataMedicao: obj.DATAMEDICAO ? obj.DATAMEDICAO.substring(0, 10) : null,
      previsaoConclusao: obj.PREVISAOCONCLUSAO
        ? obj.PREVISAOCONCLUSAO.substring(0, 10)
        : null,
      materialDisponivel: obj.MATERIALDISPONIVEL,

      regiao: obj.regiao,
      rota: obj.rota,
      cidade: obj.cidade
        ? obj.cidade
        : obj.CIDADE && obj.CIDADE.length > 0
        ? { DESCRICAO: obj.CIDADE }
        : null,
      tipo: obj.tipo ? { value: Object.keys(obj.tipo)[0] } : null,
      tipoEdificacao: obj.tipoEdificacao
        ? { value: Object.keys(obj.tipoEdificacao)[0] }
        : null,
      origemCliente: obj.origemCliente
        ? { value: Object.keys(obj.origemCliente)[0] }
        : null,
      status: obj.status ? Object.keys(obj.status)[0] : null,
      empresa: obj.empresa,
      engenheiro: obj.engenheiro,
      arquiteto: obj.arquiteto,

      fases: obj.fases ?? [],
      fasesItens: obj.fasesItens ?? [],
      parcelamentos: obj.parcelamentos ?? [],
      orcamentos: obj.orcamentos ?? [],
      devolucoes: obj.devolucoes ?? [],
      comissoes: obj.comissoes ?? [],
    }
    return objeto
  }

  // utiliza a rota create para obter os componentes
  async createConstruction() {
    let requestUrl = `${this.resource}/create`
    let data = await this.getAPI(requestUrl)
    return data
  }

  async getConstruction(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return {
      obra: this.translateFromFirebird(data.obra),
      componentes: data.componentes,
    }
  }

  async getConstructions(query = null) {
    let requestUrl = query.toOrder
      ? `${this.resource}/list-to-orders?`
      : `${this.resource}?`

    if (query) query = this.encodeQueryValues(query)

    if (query.codigo)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CODIGO=${query.codigo}`
        : `CODIGO=${query.codigo}`
    if (query.obra)
      requestUrl += this.hasParameter(requestUrl)
        ? `&OBRA=${query.obra}`
        : `OBRA=${query.obra}`
    if (query.empresa)
      requestUrl += this.hasParameter(requestUrl)
        ? `&EMPRESA=${query.empresa}`
        : `EMPRESA=${query.empresa}`
    if (query.observacao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&OBSERVACAO=${query.observacao}`
        : `OBSERVACAO=${query.observacao}`
    if (query.vendedor)
      requestUrl += this.hasParameter(requestUrl)
        ? `&VENDEDOR=${query.vendedor}`
        : `VENDEDOR=${query.vendedor}`
    if (query.useDate) {
      requestUrl += this.hasParameter(requestUrl)
        ? `&DATAINI=${query.dataInicial}`
        : `DATAINI=${query.dataInicial}`
      requestUrl += this.hasParameter(requestUrl)
        ? `&DATAFIM=${query.dataFinal}`
        : `DATAFIM=${query.dataFinal}`
    }
    if (query.status) {
      query.status.forEach((status) => {
        requestUrl += this.hasParameter(requestUrl)
          ? `&STATUS[]=${status}`
          : `STATUS[]=${status}`
      })
    }
    if (query.fases) {
      requestUrl += this.hasParameter(requestUrl)
        ? `&FASES=${query.fases}`
        : `FASES=${query.fases}`
    }

    if (query.page) {
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`
    }

    return await this.getAPI(requestUrl)
  }
}

export default new ConstructionService()
